export default __webpack_public_path__ + "static/media/gm-pt-girl.1347b484.webp";